<template>
    <div class="divAside">
        <div class="divTop">
            <div style="text-align: center;">
                <el-upload :action="uploadUrl" :show-file-list="false" :on-success="avatarSuccess"
                           :before-upload="beforeUpload">
                    <img v-if="avatar" :src="avatar" alt="" class="avatar">
                    <div v-if="!avatar" style="padding: 30px;">
                        <i class="iconfont icon-nan defaultAvatar"></i>
                    </div>
                </el-upload>
            </div>
            <p style="text-align: center;font-size: 14px;color: #000000;">{{ username }}</p>
            <div style="display: flex;">
                <div style="width: 33%;" class="divTypeEach" @click="jump('/user-realname-result')">
                    <p>
                        <i class="iconfont icon-shimingrenzheng1 topType"></i>
                    </p>
                    <p>实名认证</p>
                </div>
                <div style="width: 33%;" class="divTypeEach" @click="jump('/bind-and-password')">
                    <p>
                        <i class="iconfont icon-shouji topType"></i>
                    </p>
                    <p>手机绑定</p>
                </div>
                <div style="width: 33%;" class="divTypeEach" @click="jump('/bind-and-password')">
                    <p>
                        <i class="iconfont icon-youxiang topType"></i>
                    </p>
                    <p>邮箱绑定</p>
                </div>
            </div>
        </div>
        <div class="divMenu" style="background-color: #FFFFFF;border-radius: 5px;margin-top: 30px;">
            <p :style="{color:isAccount}" @click="jump('/user-center')" @mouseenter="enterBtn('isAccount')"
               @mouseleave="leaveBtn('isAccount')">账号信息</p>
            <p :style="{color:isBindAndPwd}" @click="jump('/bind-and-password')" @mouseenter="enterBtn('isBindAndPwd')"
               @mouseleave="leaveBtn('isBindAndPwd')">绑定与密码</p>
            <p :style="{color:isRealName}" @click="jump('/user-realname-result')" @mouseenter="enterBtn('isRealName')"
               @mouseleave="leaveBtn('isRealName')">实名认证</p>
            <p :style="{color:isTeacherCer}" @click="jump('/user-teacher-cer')" @mouseenter="enterBtn('isTeacherCer')"
               @mouseleave="leaveBtn('isTeacherCer')">教师认证</p>
            <p :style="{color:isJoinSchool}" @click="jump('/user-join-school')" @mouseenter="enterBtn('isJoinSchool')"
               @mouseleave="leaveBtn('isJoinSchool')">学校申请</p>
            <p :style="{color:isSetting}" @click="jump('/user-setting')" @mouseenter="enterBtn('isSetting')"
               @mouseleave="leaveBtn('isSetting')">主页设置</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Aside',
    created () {
        this.setActive()
        this.uploadUrl = localStorage.getItem('ServerUrl') + '/api/file/uploadfile'
        this.getUserInfo()
    },
    mounted () {
        this.$nextTick(function () {
            let that = this
            window.addEventListener('storage', (e) => {
                switch (e.key) {
                    case 'avatar':
                        if (that.avatar !== e.newValue) {
                            that.avatar = e.newValue
                        }
                        break
                }
            })
            window.addEventListener('setItemEvent', (e) => {
                if (e.key === 'avatar') {
                    if (that.avatar !== e.newValue) {
                        that.avatar = e.newValue
                    }
                }
            })
        })
    },
    data: function () {
        return {
            isAccount: '#333333',
            isBindAndPwd: '#333333',
            isRealName: '#333333',
            isTeacherCer: '#333333',
            isJoinSchool: '#333333',
            isSetting: '#333333',
            avatar: '',
            username: '',
            uploadUrl: ''
        }
    },
    methods: {
        getUserInfo () {
            let that = this
            if (!this.isEmpty(localStorage.getItem('avatar'))) {
                that.avatar = localStorage.getItem('avatar')
                if (localStorage.getItem('username')) {
                    that.username = localStorage.getItem('username')
                }
            } else {
                this.$ajax.get('/api/user/get').then(function (r) {
                    localStorage.setItem('username', r.data.username)
                    that.username = r.data.username
                    localStorage.setItem('avatar', r.data.avatar)
                    that.avatar = r.data.avatar
                })
            }
        },
        setActive: function () {
            let activeColor = '#00a4e0'
            switch (this.$route.path) {
                case '/user-center':
                    this.isAccount = activeColor
                    break
                case '/bind-and-password':
                    this.isBindAndPwd = activeColor
                    break
                case '/user-realname':
                    this.isRealName = activeColor
                    break
                case '/user-realname-result':
                    this.isRealName = activeColor
                    break
                case '/user-teacher-cer':
                    this.isTeacherCer = activeColor
                    break
                case '/user-teacher-agreement':
                    this.isTeacherCer = activeColor
                    break
                case '/user-teacher-info':
                    this.isTeacherCer = activeColor
                    break
                case '/user-join-school':
                    this.isJoinSchool = activeColor
                    break
                case '/user-setting':
                    this.isSetting = activeColor
                    break
            }
        },
        jump: function (path) {
            console.log('path:', path)
            let that = this
            if (path === '/user-teacher-cer') {
                //教师认证之前，必须做完实名认证
                this.$ajax.get('/api/user/get').then(function (res) {
                    if (!res.data.real_is_checked) {
                        that.$message.error('您还未实名，请先实名认证')
                    } else {
                        //实名认证通过，才可以访问
                        that.$router.push({
                            path: path
                        })
                    }
                })
            } else {
                this.$router.push({
                    path: path
                })
            }
        },
        enterBtn: function (type) {
            let activeColor = '#00a4e0'
            switch (type) {
                case 'isAccount':
                    this.isAccount = activeColor
                    break
                case 'isBindAndPwd':
                    this.isBindAndPwd = activeColor
                    break
                case 'isRealName':
                    this.isRealName = activeColor
                    break
                case 'isTeacherCer':
                    this.isTeacherCer = activeColor
                    break
                case 'isJoinSchool':
                    this.isJoinSchool = activeColor
                    break
                case 'isSetting':
                    this.isSetting = activeColor
                    break
            }
        },
        leaveBtn: function (type) {
            let inactiveColor = '#333333'
            switch (type) {
                case 'isAccount':
                    this.isAccount = inactiveColor
                    break
                case 'isBindAndPwd':
                    this.isBindAndPwd = inactiveColor
                    break
                case 'isRealName':
                    this.isRealName = inactiveColor
                    break
                case 'isTeacherCer':
                    this.isTeacherCer = inactiveColor
                    break
                case 'isJoinSchool':
                    this.isJoinSchool = inactiveColor
                    break
                case 'isSetting':
                    this.isSetting = inactiveColor
                    break
            }
            this.setActive()
        },
        beforeUpload (file) {
            if (file.type !== 'image/jpeg' && file.type !== 'image/png') {
                this.showError('只能是jpg或png格式')
                return false
            }
            if (file.size > 2 * 1024 * 1024) {
                this.showError('图片大小不能超过2MB')
                return false
            }
            return true
        },
        avatarSuccess (res, file) {
            //设置头像
            this.avatar = localStorage.getItem('ServerUrl') + res.data.file
            localStorage.setItem('avatar', this.avatar)
            //修改头像
            let that = this
            this.$ajax.post('/api/user/update', {
                avatar: this.avatar
            }).then(function (r) {
                that.showSuccess('头像保存成功')
            })
        },
    }
}
</script>

<style scoped="scoped">
.divAside {
}

.divAside p {
    padding: 0;
    margin: 0;
    font-size: 12px;
    color: #333333;
}

.divTop {
    background-color: #FFFFFF;
    border-radius: 5px;
    padding-top: 30px;
    padding-bottom: 30px;
}

.divTypeEach {
    margin-top: 20px;
}

.divTypeEach p {
    text-align: center;
    cursor: pointer;
}

.divTypeEach:hover p {
    color: #00a4e0;
}

.divMenu p {
    line-height: 50px;
    font-size: 14px;
    text-align: center;
    border-top: 1px solid #f8f8f8;
    cursor: pointer;
}

.divMenu p:hover {
    color: #00a4e0;
}

.topType {
    font-size: 30px;
}

.avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    box-shadow: 0px 0px 12px 2px #CCCCCC;
}

.defaultAvatar {
    font-size: 60px;
    padding: 15px;
    text-align: center;
    border: 1px #666666 dashed;
    border-radius: 50%;
    margin-top: 30px;
    margin-bottom: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/public/Aside.vue